export default function fullDateWithTime(
  unixTimestamp: number,
  locale: string = 'en-US',
  { showYear = false }: { showYear?: boolean } = {},
): string {
  const date = new Date(unixTimestamp * 1000)

  const dateFormat: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
    ...(showYear ? { year: 'numeric' } : {}),
  }

  const timeFormat: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }

  const formattedDate = date.toLocaleString(locale, dateFormat)
  const formattedTime = date.toLocaleString(locale, timeFormat)

  return `${formattedDate} - ${formattedTime}`
}
